import { useCallback } from 'react';
import { useNotificationStore } from '@/stores';
import { copyToClipboard } from '@/utils/clipboard';
import { formatResultForCopy } from '@/utils/formatResult';

/**
 * Supplies the `showToast` / `onCopyResult` props the task display components
 * expect. Both are optional in those components, so an unwired panel renders a
 * Copy button whose onClick does nothing — pass these into `commonProps`.
 */
export function useTaskResultCopy() {
  const { addNotification } = useNotificationStore();

  const showToast = useCallback(
    (message: string) => {
      addNotification({
        // The displays report failures as "Failed to ..." strings.
        type: /^failed/i.test(message) ? 'error' : 'success',
        title: 'Task Result',
        message,
        duration: 2000,
      });
    },
    [addNotification],
  );

  const copyResult = useCallback(
    async (result: unknown, taskType?: string) => {
      const copied = await copyToClipboard(formatResultForCopy(result, taskType));
      showToast(copied ? 'Copied to clipboard!' : 'Failed to copy to clipboard');
    },
    [showToast],
  );

  return { showToast, copyResult };
}
